"use client";

import { QRPreviewProps } from "./types";

import {
  PreviewApps,
  PreviewBusiness,
  PreviewCoupon,
  PreviewEvent,
  PreviewFeedback,
  PreviewImages,
  PreviewLinks,
  PreviewPdf,
  PreviewSocial,
  PreviewUrl,
  PreviewVcard,
  PreviewVideo,
  PreviewWebsite,
  PreviewWifi,
  PreviewYoutube,
  PreviewMp3,
  PreviewText,
  PreviewEmail,
  PreviewUrlStatic,
  PreviewSMS,
  PreviewWhatsapp,
} from "../previews";
import { mergePreviewDataWithTranslations } from "./utils";

import "./styles.scss";

export const QRPreviewData = ({ data, previewTranslations, isQRInit }: QRPreviewProps) => {
  const initPreviewDataJson = require("../../data/initial-previews/initPreviewData.json");
  const initPreviewData = initPreviewDataJson.find((qrdata) => data.type === qrdata.type);

  const finalInitPreviewData = mergePreviewDataWithTranslations(
    initPreviewData,
    previewTranslations,
    data.type
  );

  const getQRTypePreview = (props?: any) => {
    const previews = {
      website: PreviewWebsite,
      listoflinks: PreviewLinks,
      pdf: PreviewPdf,
      url: PreviewUrl,
      apps: PreviewApps,
      business: PreviewBusiness,
      image: PreviewImages,
      video: PreviewVideo,
      wifi: PreviewWifi,
      youtube: PreviewYoutube,
      vcard: PreviewVcard,
      social: PreviewSocial,
      event: PreviewEvent,
      coupon: PreviewCoupon,
      feedback: PreviewFeedback,
      mp3: PreviewMp3,
      text: PreviewText,
      email: PreviewEmail,
      ["url-static"]: PreviewUrlStatic,
      sms: PreviewSMS,
      whatsapp: PreviewWhatsapp,
    };

    const Component = previews[data.type];

    return Component ? (
      <Component
        {...props}
        previewTranslations={previewTranslations}
        preview={true}
        source={"editor"}
      />
    ) : (
      <div></div>
    );
  };

  return (
    <div className="qr-preview__layout__image">
      {data?.type ? (
        data?.currentPageIndex > 0 && !isQRInit ? (
          getQRTypePreview(data)
        ) : (
          getQRTypePreview({ ...finalInitPreviewData, initPreview: true })
        )
      ) : (
        <img
          src={`/images/phone-previews/phone-example.png`}
          alt="choose one qr option"
          title="QR default preview"
          className="qr-preview-img"
        />
      )}
    </div>
  );
};
